import { z } from 'zod';

export const addToBlocklistSchema = z.object({
  ccb: z.string({ required_error: 'CCB é obrigatório' }).min(1, 'CCB é obrigatório'),
  reason: z.string({ required_error: 'Motivo é obrigatório' })
    .min(1, 'Motivo é obrigatório')
    .min(10, 'Motivo deve ter no mínimo 10 caracteres'),
});

export type AddToBlocklistForm = z.infer<typeof addToBlocklistSchema>;
